// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   FaPlay,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
//   FaUserTie,
//   FaBook,
//   FaComments,
//   FaCheckCircle,
//   FaListAlt,
//   FaCalendarAlt,
//   FaUserPlus,
//   FaUser,
//   FaEnvelope,
//   FaPhone,
//   FaMapMarkerAlt,
//   FaInfoCircle,
//   FaMobileAlt,
// } from "react-icons/fa";
// import { FiDownload } from "react-icons/fi";
// import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import Footer from "../../Footer/Footer";
// import "../../../assest/css/Courses/PythonFullStack.css";

// function PythonFullStack() {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("description");
//   const [expandedLessons, setExpandedLessons] = useState([]);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     course: "Python Full Stack Development",
//     branch: "",
//   });

//   const courseContent = [
//     {
//       title: "Lesson 1: Python Fundamentals",
//       items: [
//         { title: "Variables, Data Types & Operators" },
//         { title: "Control Flow & Functions" },
//         { title: "OOP in Python" },
//         { title: "Modules & Packages" },
//       ],
//     },
//     {
//       title: "Lesson 2: Web Development with Django/Flask",
//       items: [
//         { title: "Django Models & ORM" },
//         { title: "Flask Routing & Templates" },
//         { title: "REST API Development" },
//       ],
//     },
//     {
//       title: "Lesson 3: Databases & Integration",
//       items: [
//         { title: "MySQL & PostgreSQL Basics" },
//         { title: "MongoDB & NoSQL" },
//         { title: "Database Migrations" },
//       ],
//     },
//     {
//       title: "Lesson 4: Frontend + Deployment",
//       items: [
//         { title: "React Basics for Full Stack" },
//         { title: "Authentication & JWT" },
//         { title: "Deployment on AWS/Heroku" },
//       ],
//     },
//   ];

//   const toggleLesson = (lessonIndex) => {
//     setExpandedLessons((prev) =>
//       prev.includes(lessonIndex)
//         ? prev.filter((index) => index !== lessonIndex)
//         : [...prev, lessonIndex]
//     );
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form submitted:", formData);
//     setShowSuccessModal(true);
//   };

//   const downloadSyllabus = () => {
//     const link = document.createElement("a");
//     link.href = "/Python-Full-Stack-Syllabus.pdf";
//     link.download = "Python-Full-Stack-Syllabus.pdf";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     setShowSuccessModal(false);
//   };

//   return (
//     <div className="container-fluid p-0">
//       {/* Hero Section */}
//       <div className="python-hero text-white">
//         <div className="html5-overlay position-absolute w-100 h-100"></div>
//         <div className="html5-content text-center">
//           <div
//             className="d-flex justify-content-center align-items-center"
//             style={{ height: "50vh" }}
//           >
//             <h1 className="text-white fw-bold display-4">
//               Python Full Stack Development
//             </h1>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="container py-5">
//         <div className="row">
//           {/* Left Column */}
//           <div className="col-lg-8">
//             {/* Tabs */}
//             <ul className="nav nav-tabs mb-4 border-0">
//               {["description", "content"].map((tab) => (
//                 <li className="nav-item" key={tab}>
//                   <button
//                     style={{ color: "#85bf39" }}
//                     className={`nav-link d-flex align-items-center px-4 py-2 ${activeTab === tab
//                         ? "active  fw-semibold border-bottom border-success"
//                         : "text-dark"
//                       }`}
//                     onClick={() => setActiveTab(tab)}
//                   >
//                     {tab === "description" && <FaBook className="me-2" />}
//                     {tab === "content" && <FaListAlt className="me-2" />}
//                     {tab.charAt(0).toUpperCase() + tab.slice(1)}
//                   </button>
//                 </li>
//               ))}
//             </ul>

//             {/* Tab Content */}
//             {activeTab === "description" && (
//               <div className="p-4 bg-white rounded shadow-sm">
//                 <h5 className="fw-bold mb-3 d-flex align-items-center">
//                   <FaBook style={{ color: "#85bf39" }} className=" me-2" /> Course Description
//                 </h5>
//                 <p className="text-muted">
//                   Become a full stack Python developer by mastering Python,
//                   Django/Flask, frontend technologies, and databases. This
//                   course covers everything from backend APIs to responsive
//                   frontend design and cloud deployment.
//                 </p>
//                 <p className="text-muted">
//                   You'll gain hands-on experience building real-world projects
//                   with Python, integrating with MySQL/MongoDB, creating REST
//                   APIs, and deploying apps on the cloud.
//                 </p>

//                 <h5 className="fw-bold mt-5 mb-3 d-flex align-items-center">
//                   <FaCheckCircle style={{ color: "#85bf39" }} className=" me-2" /> What You Will
//                   Learn
//                 </h5>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <ul className="list-unstyled">
//                       <li className="mb-2 d-flex align-items-start">
//                         <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
//                         Build dynamic web apps with Python & Django/Flask
//                       </li>
//                       <li className="mb-2 d-flex align-items-start">
//                         <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
//                         Integrate with MySQL & MongoDB databases
//                       </li>
//                     </ul>
//                   </div>
//                   <div className="col-md-6">
//                     <ul className="list-unstyled">
//                       <li className="mb-2 d-flex align-items-start">
//                         <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
//                         Frontend development with React/HTML/CSS
//                       </li>
//                       <li className="mb-2 d-flex align-items-start">
//                         <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
//                         Deploy full-stack apps to cloud platforms
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {activeTab === "content" && (
//               <div className="p-4 bg-white rounded shadow">
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <h5 className="fw-bold mb-0 d-flex align-items-center">
//                     <FaListAlt style={{ color: "#85bf39" }} className=" me-2" /> Course Content
//                   </h5>
//                   <button
//                     style={{ color: "#85bf39" }}
//                     className="btn btn-outline btn-sm d-flex align-items-center"
//                     onClick={() =>
//                       setExpandedLessons(
//                         expandedLessons.length === courseContent.length
//                           ? []
//                           : courseContent.map((_, index) => index)
//                       )
//                     }
//                   >
//                     {expandedLessons.length === courseContent.length ? (
//                       <>
//                         <IoIosArrowDown className="me-1" /> Collapse All
//                       </>
//                     ) : (
//                       <>
//                         <IoIosArrowForward className="me-1" /> Expand All
//                       </>
//                     )}
//                   </button>
//                 </div>
//                 <div className="card border-0">
//                   <div className="card-body p-0">
//                     <table className="table table-borderless mb-0">
//                       <tbody>
//                         {courseContent.map((lesson, index) => (
//                           <React.Fragment key={index}>
//                             <tr
//                               className="border-top"
//                               style={{ cursor: "pointer" }}
//                               onClick={() => toggleLesson(index)}
//                             >
//                               <td className="w-75 py-3">
//                                 <div className="d-flex align-items-center">
//                                   <span
//                                     style={{ color: "#85bf39" }}
//                                     className={`me-2 ${expandedLessons.includes(index)
//                                         ? ""
//                                         : ""
//                                       }`}
//                                   >
//                                     {expandedLessons.includes(index) ? (
//                                       <IoIosArrowDown />
//                                     ) : (
//                                       <IoIosArrowForward />
//                                     )}
//                                   </span>
//                                   <span className="fw-semibold">
//                                     {lesson.title}
//                                   </span>
//                                 </div>
//                               </td>
//                               <td className="text-end text-muted">
//                                 {lesson.duration}
//                               </td>
//                             </tr>
//                             {expandedLessons.includes(index) &&
//                               lesson.items.map((item, itemIndex) => (
//                                 <tr
//                                   key={`${index}-${itemIndex}`}
//                                   className="bg-light"
//                                 >
//                                   <td className="ps-5 py-2 d-flex align-items-center">
//                                     <span className="text-muted">
//                                       {item.title}
//                                     </span>
//                                   </td>
//                                   <td className="text-end text-muted">
//                                     {item.duration}
//                                   </td>
//                                 </tr>
//                               ))}
//                           </React.Fragment>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Right Column - Enquiry Form */}
//           <div className="col-lg-4 mt-5 mt-lg-0">
//             <div
//               className="bg-white p-4 rounded shadow sticky-top"
//               style={{ top: "100px", zIndex: 0 }}
//             >
//               <h5 className="fw-bold mb-4 d-flex align-items-center">
//                 <FaUserPlus style={{ color: "#85bf39" }} className=" me-2" /> Enroll in This
//                 Course
//               </h5>
//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3">
//                   <label
//                     htmlFor="name"
//                     className="form-label d-flex align-items-center"
//                   >
//                     <FaUser style={{ color: "#85bf39" }} className="me-2 " /> Full Name
//                   </label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     placeholder="Your Name"
//                     className="form-control rounded-pill"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label
//                     htmlFor="email"
//                     className="form-label d-flex align-items-center"
//                   >
//                     <FaEnvelope style={{ color: "#85bf39" }} className="me-2 " /> Email Address
//                   </label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     placeholder="Your Email"
//                     className="form-control rounded-pill"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label
//                     htmlFor="phone"
//                     className="form-label d-flex align-items-center"
//                   >
//                     <FaPhone style={{ color: "#85bf39" }} className="me-2 " /> Phone Number
//                   </label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     placeholder="Mobile Number"
//                     className="form-control rounded-pill"
//                     value={formData.phone}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label
//                     htmlFor="course"
//                     className="form-label d-flex align-items-center"
//                   >
//                     <FaBook style={{ color: "#85bf39" }} className="me-2" /> Course
//                   </label>
//                   <select
//                     id="course"
//                     name="course"
//                     className="form-select rounded-pill"
//                     value={formData.course}
//                     onChange={handleInputChange}
//                   >
//                     <option value="Python Full Stack Development">
//                       Python Full Stack Development
//                     </option>

//                   </select>
//                 </div>
//                 <button
//                   style={{ backgroundColor: "#85bf39", color: "#fff" }}
//                   type="submit"
//                   className="btn btn-fill w-100 mt-2 d-flex align-items-center justify-content-center"
//                 >
//                   <FaUserPlus className="me-2" /> Enroll Now
//                 </button>

//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Success Modal */}
//       <Modal
//         show={showSuccessModal}
//         onHide={() => setShowSuccessModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title className="d-flex align-items-center">
//             <FaCheckCircle style={{ color: "#85bf39" }} className=" me-2" /> Enrollment
//             Successful!
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             Thank you for enrolling in our Python Full Stack Development course!
//           </p>
//           <p>Would you like to download the course syllabus?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
//             Maybe Later
//           </Button>
//           <Button
//             style={{ color: "#85bf39" }}
//             variant=""
//             onClick={downloadSyllabus}
//             className="d-flex align-items-center"
//           >
//             <FiDownload className="me-2" /> Download Syllabus
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Footer />
//     </div>
//   );
// }

// export default PythonFullStack;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaPlay,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaUserTie,
  FaBook,
  FaComments,
  FaCheckCircle,
  FaListAlt,
  FaCalendarAlt,
  FaUserPlus,
  FaUser,
  FaPhone,
  FaMapMarkerAlt,
  FaInfoCircle,
  FaMobileAlt,
} from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Footer from "../../Footer/Footer";
import "../../../assest/css/Courses/PythonFullStack.css";

function PythonFullStack() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("description");
  const [expandedLessons, setExpandedLessons] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // NEW: Loading state
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    course: "Python Full Stack Development",
    preferred_mode: "", // NEW: For preferred_mode (required by backend)
  });

  const courseContent = [
    {
      title: "Lesson 1: Python Fundamentals",
      items: [
        { title: "Variables, Data Types & Operators" },
        { title: "Control Flow & Functions" },
        { title: "OOP in Python" },
        { title: "Modules & Packages" },
      ],
    },
    {
      title: "Lesson 2: Web Development with Django/Flask",
      items: [
        { title: "Django Models & ORM" },
        { title: "Flask Routing & Templates" },
        { title: "REST API Development" },
      ],
    },
    {
      title: "Lesson 3: Databases & Integration",
      items: [
        { title: "MySQL & PostgreSQL Basics" },
        { title: "MongoDB & NoSQL" },
        { title: "Database Migrations" },
      ],
    },
    {
      title: "Lesson 4: Frontend + Deployment",
      items: [
        { title: "React Basics for Full Stack" },
        { title: "Authentication & JWT" },
        { title: "Deployment on AWS/Heroku" },
      ],
    },
  ];

  const toggleLesson = (lessonIndex) => {
    setExpandedLessons((prev) =>
      prev.includes(lessonIndex)
        ? prev.filter((index) => index !== lessonIndex)
        : [...prev, lessonIndex]
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);

    // Validation
    if (!formData.first_name || !formData.last_name || !formData.phone || !formData.preferred_mode) {
      alert("Please fill all required fields.");
      return;
    }

    setIsSubmitting(true);
    try {
      // Map form data to backend format
      const submitData = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        phone_number: formData.phone,
        interested_course: formData.course,
        preferred_mode: formData.preferred_mode,
        source: "Python Full Stack Page", // NEW: Default source
        notes: "", // Optional
        status: "new", // Default status
      };

      // POST to backend (assume API base URL is http://localhost:5000/api)
      const response = await fetch("http://localhost:5000/api/course-enquiries", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      });

      if (!response.ok) {
        throw new Error("Failed to submit enquiry");
      }

      const savedEnquiry = await response.json();
      console.log("Enquiry saved:", savedEnquiry);

      // Show success modal on success
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const downloadSyllabus = () => {
    const link = document.createElement("a");
    link.href = "/Python-Full-Stack-Syllabus.pdf";
    link.download = "Python-Full-Stack-Syllabus.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowSuccessModal(false);
  };

  return (
    <div className="container-fluid p-0">
      {/* Hero Section */}
      <div className="python-hero text-white">
        <div className="html5-overlay position-absolute w-100 h-100"></div>
        <div className="html5-content text-center">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "50vh" }}
          >
            <h1 className="text-white fw-bold display-4">
              Python Full Stack Development
            </h1>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container py-5">
        <div className="row">
          {/* Left Column */}
          <div className="col-lg-8">
            {/* Tabs */}
            <ul className="nav nav-tabs mb-4 border-0">
              {["description", "content"].map((tab) => (
                <li className="nav-item" key={tab}>
                  <button
                    style={{ color: "#85bf39" }}
                    className={`nav-link d-flex align-items-center px-4 py-2 ${activeTab === tab
                        ? "active fw-semibold border-bottom border-success"
                        : "text-dark"
                      }`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab === "description" && <FaBook className="me-2" />}
                    {tab === "content" && <FaListAlt className="me-2" />}
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                </li>
              ))}
            </ul>
            {/* Tab Content */}
            {activeTab === "description" && (
              <div className="p-4 bg-white rounded shadow-sm">
                <h5 className="fw-bold mb-3 d-flex align-items-center">
                  <FaBook style={{ color: "#85bf39" }} className=" me-2" /> Course Description
                </h5>
                <p className="text-muted">
                  Become a full stack Python developer by mastering Python,
                  Django/Flask, frontend technologies, and databases. This
                  course covers everything from backend APIs to responsive
                  frontend design and cloud deployment.
                </p>
                <p className="text-muted">
                  You'll gain hands-on experience building real-world projects
                  with Python, integrating with MySQL/MongoDB, creating REST
                  APIs, and deploying apps on the cloud.
                </p>
                <h5 className="fw-bold mt-5 mb-3 d-flex align-items-center">
                  <FaCheckCircle style={{ color: "#85bf39" }} className=" me-2" /> What You Will
                  Learn
                </h5>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2 d-flex align-items-start">
                        <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
                        Build dynamic web apps with Python & Django/Flask
                      </li>
                      <li className="mb-2 d-flex align-items-start">
                        <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
                        Integrate with MySQL & MongoDB databases
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2 d-flex align-items-start">
                        <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
                        Frontend development with React/HTML/CSS
                      </li>
                      <li className="mb-2 d-flex align-items-start">
                        <FaStar style={{ color: "#85bf39" }} className=" mt-1 me-2" size={12} />
                        Deploy full-stack apps to cloud platforms
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "content" && (
              <div className="p-4 bg-white rounded shadow">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold mb-0 d-flex align-items-center">
                    <FaListAlt style={{ color: "#85bf39" }} className=" me-2" /> Course Content
                  </h5>
                  <button
                    style={{ color: "#85bf39" }}
                    className="btn btn-outline btn-sm d-flex align-items-center"
                    onClick={() =>
                      setExpandedLessons(
                        expandedLessons.length === courseContent.length
                          ? []
                          : courseContent.map((_, index) => index)
                      )
                    }
                  >
                    {expandedLessons.length === courseContent.length ? (
                      <>
                        <IoIosArrowDown className="me-1" /> Collapse All
                      </>
                    ) : (
                      <>
                        <IoIosArrowForward className="me-1" /> Expand All
                      </>
                    )}
                  </button>
                </div>
                <div className="card border-0">
                  <div className="card-body p-0">
                    <table className="table table-borderless mb-0">
                      <tbody>
                        {courseContent.map((lesson, index) => (
                          <React.Fragment key={index}>
                            <tr
                              className="border-top"
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleLesson(index)}
                            >
                              <td className="w-75 py-3">
                                <div className="d-flex align-items-center">
                                  <span
                                    style={{ color: "#85bf39" }}
                                    className={`me-2 ${expandedLessons.includes(index)
                                        ? ""
                                        : ""
                                      }`}
                                  >
                                    {expandedLessons.includes(index) ? (
                                      <IoIosArrowDown />
                                    ) : (
                                      <IoIosArrowForward />
                                    )}
                                  </span>
                                  <span className="fw-semibold">
                                    {lesson.title}
                                  </span>
                                </div>
                              </td>
                              <td className="text-end text-muted">
                                {lesson.duration}
                              </td>
                            </tr>
                            {expandedLessons.includes(index) &&
                              lesson.items.map((item, itemIndex) => (
                                <tr
                                  key={`${index}-${itemIndex}`}
                                  className="bg-light"
                                >
                                  <td className="ps-5 py-2 d-flex align-items-center">
                                    <span className="text-muted">
                                      {item.title}
                                    </span>
                                  </td>
                                  <td className="text-end text-muted">
                                    {item.duration}
                                  </td>
                                </tr>
                              ))}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Right Column - Enquiry Form */}
          <div className="col-lg-4 mt-5 mt-lg-0">
            <div
              className="bg-white p-4 rounded shadow sticky-top"
              style={{ top: "100px", zIndex: 0 }}
            >
              <h5 className="fw-bold mb-4 d-flex align-items-center">
                <FaUserPlus style={{ color: "#85bf39" }} className=" me-2" /> Enroll in This
                Course
              </h5>
              <form onSubmit={handleSubmit}>
                {/* Split name into first and last name */}
                <div className="mb-3">
                  <label
                    htmlFor="first_name"
                    className="form-label d-flex align-items-center"
                  >
                    <FaUser style={{ color: "#85bf39" }} className="me-2 " /> First Name *
                  </label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    placeholder="First Name"
                    className="form-control rounded-pill"
                    value={formData.first_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="last_name"
                    className="form-label d-flex align-items-center"
                  >
                    <FaUser style={{ color: "#85bf39" }} className="me-2 " /> Last Name *
                  </label>
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    placeholder="Last Name"
                    className="form-control rounded-pill"
                    value={formData.last_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="phone"
                    className="form-label d-flex align-items-center"
                  >
                    <FaPhone style={{ color: "#85bf39" }} className="me-2 " /> Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Mobile Number"
                    className="form-control rounded-pill"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="course"
                    className="form-label d-flex align-items-center"
                  >
                    <FaBook style={{ color: "#85bf39" }} className="me-2" /> Course
                  </label>
                  <select
                    id="course"
                    name="course"
                    className="form-select rounded-pill"
                    value={formData.course}
                    onChange={handleInputChange}
                    disabled // Fixed course
                  >
                    <option value="Python Full Stack Development">
                      Python Full Stack Development
                    </option>
                  </select>
                </div>
                {/* Preferred mode select (required by backend) - Only Online and Offline */}
                <div className="mb-3">
                  <label
                    htmlFor="preferred_mode"
                    className="form-label d-flex align-items-center"
                  >
                    <FaMobileAlt style={{ color: "#85bf39" }} className="me-2 " /> Preferred Mode *
                  </label>
                  <select
                    id="preferred_mode"
                    name="preferred_mode"
                    className="form-select rounded-pill"
                    value={formData.preferred_mode}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Mode</option>
                    <option value="Online">Online</option>
                    <option value="Offline">Offline</option>
                  </select>
                </div>
                <button
                  style={{ backgroundColor: "#85bf39", color: "#fff" }}
                  type="submit"
                  className="btn btn-fill w-100 mt-2 d-flex align-items-center justify-content-center"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : (
                    <>
                      <FaUserPlus className="me-2" /> Enroll Now
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Success Modal */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center">
            <FaCheckCircle style={{ color: "#85bf39" }} className=" me-2" /> Enrollment
            Successful!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Thank you for enrolling in our Python Full Stack Development course! Your enquiry has been saved.
          </p>
          <p>Would you like to download the course syllabus?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
            Maybe Later
          </Button>
          <Button
            style={{ color: "#85bf39" }}
            variant=""
            onClick={downloadSyllabus}
            className="d-flex align-items-center"
          >
            <FiDownload className="me-2" /> Download Syllabus
          </Button>
        </Modal.Footer>
      </Modal>
      <Footer />
    </div>
  );
}

export default PythonFullStack;